import { Outlet } from 'react-router-dom'
import { UnifiedNavigation } from '@/components/navigation/UnifiedNavigation'

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-background">
      <UnifiedNavigation preset="admin" />
      <main className="container mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  )
}
